module.exports = __webpack_public_path__ + "assets/check.f932f292.svg";